import { useNavigate } from 'react-router';
import { AssetUrls } from 'config/assets';
import './EliteUpsellBanner.css';

const BNG_47_SCRYFALL_ID = '546dae51-070c-4f3f-b0b4-6b88ff314af1';

type EliteUpsellBannerVariant = 'sidebar' | 'dropdown';
type EliteUpsellBannerRef = 'sidebar' | 'header_dropdown';

interface EliteUpsellBannerProps {
  variant: EliteUpsellBannerVariant;
  refSource: EliteUpsellBannerRef;
  onNavigate?: () => void;
}

const VARIANT_COPY: Record<EliteUpsellBannerVariant, string> = {
  sidebar: 'Custom colors, badges, and more.',
  dropdown: 'Your profile, in foil.',
};

export const EliteUpsellBanner = ({ variant, refSource, onNavigate }: EliteUpsellBannerProps) => {
  const navigate = useNavigate();
  const bgUrl = AssetUrls.cards.getCardImage(BNG_47_SCRYFALL_ID, 'art_crop');

  const handleClick = () => {
    onNavigate?.();
    navigate(`/elite?ref=${refSource}`);
  };

  return (
    <div
      className={`elite-upsell-promo elite-upsell-promo--${variant}`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div
        className="elite-upsell-promo__inner"
        style={{ backgroundImage: `url(${bgUrl})` }}
      >
        <div className="elite-upsell-promo__overlay" />
        <div className="elite-upsell-promo__content">
          <div className="elite-upsell-promo__header">
            <img
              src={AssetUrls.icons.elite.badge}
              alt=""
              className="elite-upsell-promo__badge"
            />
            <span className="elite-upsell-promo__label">Elite</span>
          </div>
          <div className="elite-upsell-promo__description">
            {VARIANT_COPY[variant]}
          </div>
          <button
            type="button"
            className="elite-upsell-promo__cta"
            onClick={(e) => {
              e.stopPropagation();
              handleClick();
            }}
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
};

export default EliteUpsellBanner;
